<template>
  <div class="animated fadeIn">
    <filters :scope="filtersScope">
    </filters>
    <RefundsTabs></RefundsTabs>

    <div class="container__table excel" style="overflow:hidden; width:100%; z-index: -10;">
      <div id="swipe" v-hammer:pan="onSwipe" style="display:flex;flex-wrap: nowrap; width: 100%; z-index: -10;"
           :style="{ 'transform': 'translate3d(' + x + 'px, 0px, 0px)'}">
            <StatisticTable :headColumns="headColumns"
                            :footColumns="footColumns"
                            :rows="rows"
                            @isPopup="isPopup"
                            :title="`${$t('pages.ref_cancel_operators')}`">
            </StatisticTable>
      </div>
    </div>
  </div>
</template>

<script>
import Filters from '../../../components/Filters'
import RefundsTabs from './RefundsTabs'
import { map, sum } from 'lodash'
import StatisticTable from '../../../components/StatisticTable'
import API from '../../../api/API'
import Helper from '../../../api/Helper'
import Storage from '../../../api/Storage'
export default {
  name: 'CancelOperators',
  components: {
    StatisticTable,
    RefundsTabs,
    Filters
  },
  data () {
    return {
      x: 0,
      filtersScope: {
        dateFilter: true,
        offerFilter: true,
        courierFilter: true,
        byManualFilter: true
      },
      headColumns: [
        {label: this.$root.$t('statistic.operator'), field: 'operator'},
        {label: this.$root.$t('statistic.processed_all'), field: 'processed_all', width: '100px'},
        {label: this.$root.$t('statistic.approve'), field: 'approve'},
        {label: this.$root.$t('statistic.averageBill'), field: 'averageBill', width: '100px'},
        {label: this.$root.$t('statistic.total_cancel'), field: 'total_cancel', colspan: 3},

        // Valid
        {label: this.$root.$t('statistic.expensive'), field: 'expensive', id_reason: 2, colspan: 2},
        {label: this.$root.$t('statistic.changed_mind'), field: 'changed_mind', id_reason: 3, colspan: 2},
        {label: this.$root.$t('statistic.no_payment_method'), field: 'no_payment_method', id_reason: 4, colspan: 2},
        {label: this.$root.$t('statistic.bad_reputation'), field: 'bad_reputation', id_reason: 9, colspan: 2},
        {label: this.$root.$t('statistic.form_release'), field: 'form_release', id_reason: 10, colspan: 2},
        {label: this.$root.$t('statistic.want_guarantees'), field: 'want_guarantees', id_reason: 11, colspan: 2},
        {label: this.$root.$t('statistic.medical_contraindications'), field: 'medical_contraindications', id_reason: 12, colspan: 2},
        {label: this.$root.$t('statistic.not_allowed'), field: 'not_allowed', id_reason: 14, colspan: 2},
        {label: this.$root.$t('statistic.consultation'), field: 'consultation', id_reason: 16, colspan: 2},
        {label: this.$root.$t('statistic.not_processed'), field: 'not_processed', id_reason: 23, colspan: 2},
        {label: this.$root.$t('statistic.expensive_delivery'), field: 'expensive_delivery', id_reason: 24, colspan: 2},
        {label: this.$root.$t('statistic.no_pay_tax'), field: 'no_pay_tax', id_reason: 27, colspan: 2},

        // Invalid
        {label: this.$root.$t('statistic.not_order'), field: 'not_order', id_reason: 1, colspan: 2},
        {label: this.$root.$t('statistic.not_delivery_time'), field: 'not_delivery_time', id_reason: 5, colspan: 2},
        {label: this.$root.$t('statistic.already_bought'), field: 'already_bought', id_reason: 6, colspan: 2},
        {label: this.$root.$t('statistic.no_nearby'), field: 'no_nearby', id_reason: 7, colspan: 2},
        {label: this.$root.$t('statistic.suite_different_price'), field: 'suite_different_price', id_reason: 8, colspan: 2},
        // {label: this.$root.$t('statistic.other_information'), field: 'other_information', id_reason: 13, colspan: 2},
        {label: this.$root.$t('statistic.won_gift'), field: 'won_gift', id_reason: 15, colspan: 2},
        {label: this.$root.$t('statistic.language_barrier'), field: 'language_barrier', id_reason: 17, colspan: 2},
        {label: this.$root.$t('statistic.wrong_data'), field: 'wrong_data', id_reason: 18, colspan: 2},
        {label: this.$root.$t('statistic.not_ringing_long_time'), field: 'not_ringing_long_time', id_reason: 19, colspan: 2},
        {label: this.$root.$t('statistic.drop_calls'), field: 'drop_calls', id_reason: 20, colspan: 2},
        {label: this.$root.$t('statistic.not_make_contact'), field: 'not_make_contact', id_reason: 21, colspan: 2},
        {label: this.$root.$t('statistic.silent'), field: 'silent', id_reason: 22, colspan: 2},
        {label: this.$root.$t('statistic.no_coverage'), field: 'no_coverage', id_reason: 25, colspan: 2},
        {label: this.$root.$t('statistic.blacklisted_customer'), field: 'blacklisted_customer', id_reason: 26, colspan: 2},
        {label: this.$root.$t('statistic.under_18'), field: 'under_18', id_reason: 28, colspan: 2},
        {label: this.$root.$t('statistic.any_reasons'), field: 'any_reasons', id_reason: 0, colspan: 2},
        {label: this.$root.$t('statistic.another'), field: 'another', id_reason: 99, colspan: 2}
      ],
      rows: [],
      footColumns: {}
    }
  },
  mounted () {
    this.calculateRows()
    this.$root.$on('filters_load_new_data', () => {
      this.calculateRows()
    })
  },
  methods: {
    isPopup (cell) {
      let el = document.createElement('textarea')
      el.value = cell.value.trim()
      el.setAttribute('readonly', '')
      el.style.position = 'absolute'
      el.style.left = '-9999px'
      document.body.appendChild(el)
      el.select()
      document.execCommand('copy')
      document.body.removeChild(el)
      alert('Скопирован оператор ' + el.value)
    },
    onSwipe (e) {
      const offset = document.getElementById('swipe').offsetWidth
      const scroll = document.getElementById('swipe').scrollWidth
      const width = scroll - offset
      if (width > 0) {
        if (e.deltaX >= 0) {
          this.x += e.distance / 10
        } else {
          this.x -= e.distance / 10
        }
        if (this.x > 0) {
          this.x = 0
        }
        if (Math.abs(this.x) > width) {
          this.x = -width
        }
      }
    },
    // Я бы ввел уголовную статью за такой код
    calculateRows () {
      API.getOperators(Helper.getCountryList()).then(operators => {
        API.getRefundsCancelOperators().then(response => {
          this.rows = []
          this.footColumns = {}
          map(response.body, (dataOperator, indexOperator) => {
            let sumCanceled = 0
            let sumProcessed = 0
            let sumApproved = 0
            let sumTotalPrice = 0.0
            let expensiveCount = 0
            let changedMindCount = 0
            let badReputationCount = 0
            let consultationCount = 0
            let notAllowedCount = 0
            let medicalContraindicationsCount = 0
            let notOrderCount = 0
            let notRingingLongTimeCount = 0
            let notMakeContactCount = 0
            let noCoverageCount = 0
            let blacklistedCustomerCount = 0
            let notDeliveryTimeCount = 0
            let alreadyBoughtCount = 0
            let suiteDifferentPriceCount = 0

            // Переменные для новых валидных причин отмен
            let noPaymentMethodCount = 0 // 4
            let formReleaseCount = 0 // 10
            let guaranteesCount = 0 // 11
            let noProcessedCount = 0 // 23
            let expensiveDeliveryCount = 0 // 24
            let noPayTaxCount = 0 // 27

            // Переменные для новых невалидных причин отмен
            let noClientNearbyCount = 0 // 7
            let otherInformationCount = 0 // 13
            let wonGiftCount = 0 // 15
            let languageBarrierCount = 0 // 17
            let wrongNumberCount = 0 // 18
            let dropCallCount = 0 // 20
            let silentCount = 0 // 22
            let under18Count = 0 // 28

            let anotherCount = 0
            let anyReasonsCount = 0
            let redCountCol = 0
            let grayCountCol = 0

            const percentCanceled = reasonCount => Helper.percents(sumCanceled, reasonCount)

            map(dataOperator, (data) => {
              sumProcessed += parseInt(data.processed)
              sumApproved += parseInt(data.approved)
              sumTotalPrice += parseFloat(data.total_bill_usd)
              sumCanceled += data.canceled

              switch (data.cancel_reason) {
                case 0:
                  anyReasonsCount = data.canceled
                  break
                case 1:
                  notOrderCount = data.canceled
                  break
                case 2:
                  expensiveCount = data.canceled
                  break
                case 3:
                  changedMindCount = data.canceled
                  break
                case 4:
                  noPaymentMethodCount = data.canceled
                  break
                case 5:
                  notDeliveryTimeCount = data.canceled
                  break
                case 6:
                  alreadyBoughtCount = data.canceled
                  break
                case 7:
                  noClientNearbyCount = data.canceled
                  break
                case 8:
                  suiteDifferentPriceCount = data.canceled
                  break
                case 9:
                  badReputationCount = data.canceled
                  break
                case 10:
                  formReleaseCount = data.canceled
                  break
                case 11:
                  guaranteesCount = data.canceled
                  break
                case 12:
                  notAllowedCount = data.canceled
                  break
                case 13:
                  otherInformationCount = data.canceled
                  break
                case 14:
                  medicalContraindicationsCount = data.canceled
                  break
                case 15:
                  wonGiftCount = data.canceled
                  break
                case 16:
                  consultationCount = data.canceled
                  break
                case 17:
                  languageBarrierCount = data.canceled
                  break
                case 18:
                  wrongNumberCount = data.canceled
                  break
                case 19:
                  notRingingLongTimeCount = data.canceled
                  break
                case 20:
                  dropCallCount = data.canceled
                  break
                case 21:
                  notMakeContactCount = data.canceled
                  break
                case 22:
                  silentCount = data.canceled
                  break
                case 23:
                  noProcessedCount = data.canceled
                  break
                case 24:
                  expensiveDeliveryCount = data.canceled
                  break
                case 25:
                  noCoverageCount = data.canceled
                  break
                case 26:
                  blacklistedCustomerCount = data.canceled
                  break
                case 27:
                  noPayTaxCount = data.canceled
                  break
                case 28:
                  under18Count = data.canceled
                  break
                case 99:
                  anotherCount += data.canceled
                  break
                default:
                  anotherCount += data.canceled
              }
            })

            redCountCol = sum([
              expensiveCount,
              changedMindCount,
              badReputationCount,
              consultationCount,
              notAllowedCount,
              medicalContraindicationsCount,
              noPaymentMethodCount,
              formReleaseCount,
              guaranteesCount,
              noProcessedCount,
              expensiveDeliveryCount,
              noPayTaxCount
            ])

            grayCountCol = sum([
              notOrderCount,
              notRingingLongTimeCount,
              notMakeContactCount,
              noCoverageCount,
              blacklistedCustomerCount,
              notDeliveryTimeCount,
              alreadyBoughtCount,
              suiteDifferentPriceCount,
              noClientNearbyCount,
              otherInformationCount,
              wonGiftCount,
              languageBarrierCount,
              wrongNumberCount,
              dropCallCount,
              silentCount,
              under18Count,
              anotherCount,
              anyReasonsCount
            ])

            this.rows.push({
              operator: {
                value: `${Helper.getOperatorLogin(operators.body, indexOperator)} ${Storage.developMode ? `(${indexOperator})` : ''}`,
                popup: true
              },
              processed_all: {
                value: sumProcessed
              },
              approved: {
                value: Helper.percents(sumProcessed, sumApproved),
                approvedSum: sumApproved
              },
              averageBill: {
                value: sumApproved > 0 ? '$ ' + (sumTotalPrice / sumApproved).toFixed(2) : '$ 0.00',
                averageBillTotal: sumTotalPrice
              },
              total_cancel: {
                value: sumCanceled
              },
              total_cancel_red: {
                value: sumCanceled > 0 ? ((redCountCol / sumCanceled) * 100).toFixed(1) + '%' : '0 %'
              },
              total_cancel_gray: {
                value: sumCanceled > 0 ? ((grayCountCol / sumCanceled) * 100).toFixed(1) + '%' : '0 %'
              },

              expensive: {
                value: expensiveCount
              },
              expensivePercent: {
                value: percentCanceled(expensiveCount)
              },

              changed_mind: {
                value: changedMindCount
              },
              changed_mindPercent: {
                value: percentCanceled(changedMindCount)
              },

              no_payment_method: {
                value: noPaymentMethodCount
              },
              no_payment_methodPercent: {
                value: percentCanceled(noPaymentMethodCount)
              },

              bad_reputation: {
                value: badReputationCount
              },
              bad_reputationPercent: {
                value: percentCanceled(badReputationCount)
              },

              form_release: {
                value: formReleaseCount
              },
              form_releasePercent: {
                value: percentCanceled(formReleaseCount)
              },

              want_guarantees: {
                value: guaranteesCount
              },
              want_guaranteesPercent: {
                value: percentCanceled(guaranteesCount)
              },

              medical_contraindications: {
                value: medicalContraindicationsCount
              },
              medical_contraindicationsPercent: {
                value: percentCanceled(medicalContraindicationsCount)
              },

              not_allowed: {
                value: notAllowedCount
              },
              not_allowedPercent: {
                value: percentCanceled(notAllowedCount)
              },

              consultation: {
                value: consultationCount
              },
              consultationPercent: {
                value: percentCanceled(consultationCount)
              },

              not_processed: {
                value: noProcessedCount
              },
              not_processedPercent: {
                value: percentCanceled(noProcessedCount)
              },

              expensive_delivery: {
                value: expensiveDeliveryCount
              },
              expensive_deliveryPercent: {
                value: percentCanceled(expensiveDeliveryCount)
              },

              no_pay_tax: {
                value: noPayTaxCount
              },
              no_pay_taxPercent: {
                value: percentCanceled(noPayTaxCount)
              },

              not_order: {
                value: notOrderCount
              },
              not_orderPercent: {
                value: percentCanceled(notOrderCount)
              },

              not_delivery_time: {
                value: notDeliveryTimeCount
              },
              not_delivery_timePercent: {
                value: percentCanceled(notDeliveryTimeCount)
              },

              already_bought: {
                value: alreadyBoughtCount
              },
              already_boughtPercent: {
                value: percentCanceled(alreadyBoughtCount)
              },

              no_nearby: {
                value: noClientNearbyCount
              },
              no_nearbyPercent: {
                value: percentCanceled(noClientNearbyCount)
              },

              suite_different_price: {
                value: suiteDifferentPriceCount
              },
              suite_different_pricePercent: {
                value: percentCanceled(suiteDifferentPriceCount)
              },

              other_information: {
                value: otherInformationCount
              },
              other_informationPercent: {
                value: percentCanceled(otherInformationCount)
              },

              won_gift: {
                value: wonGiftCount
              },
              won_giftPercent: {
                value: percentCanceled(wonGiftCount)
              },

              language_barrier: {
                value: languageBarrierCount
              },
              language_barrierPercent: {
                value: percentCanceled(languageBarrierCount)
              },

              wrong_data: {
                value: wrongNumberCount
              },
              wrong_dataPercent: {
                value: percentCanceled(wrongNumberCount)
              },

              not_ringing_long_time: {
                value: notRingingLongTimeCount
              },
              not_ringing_long_timePercent: {
                value: percentCanceled(notRingingLongTimeCount)
              },

              drop_calls: {
                value: dropCallCount
              },
              drop_callsPercent: {
                value: percentCanceled(dropCallCount)
              },

              not_make_contact: {
                value: notMakeContactCount
              },
              not_make_contactPercent: {
                value: percentCanceled(notMakeContactCount)
              },

              silent: {
                value: silentCount
              },
              silentPercent: {
                value: percentCanceled(silentCount)
              },

              no_coverage: {
                value: noCoverageCount
              },
              no_coveragePercent: {
                value: percentCanceled(noCoverageCount)
              },

              blacklisted_customer: {
                value: blacklistedCustomerCount
              },
              blacklisted_customerPercent: {
                value: percentCanceled(blacklistedCustomerCount)
              },

              under_18: {
                value: under18Count
              },
              under_18Percent: {
                value: percentCanceled(under18Count)
              },

              any_reasons: {
                value: anyReasonsCount
              },
              any_reasonsPercent: {
                value: percentCanceled(anyReasonsCount)
              },
              another: {
                value: anotherCount
              },
              anotherPercent: {
                value: percentCanceled(anotherCount)
              }
            })
          })

          let totalProcessed = 0
          let totalApproved = 0
          let totalAverageBill = 0.0
          let totalCancel = 0
          let totalCancelRed = 0
          let totalCancelGray = 0
          let totalExpensive = 0
          let totalChangedMind = 0
          let totalBadReputation = 0
          let totalConsultation = 0
          let totalNotAllowed = 0
          let totalMedicalContraindications = 0
          let totalNotOrder = 0
          let totalNotRingingLongTime = 0
          let totalNotMakeContact = 0
          let totalNoCoverage = 0
          let totalBlacklistedCustomer = 0
          let totalNotDeliveryTime = 0
          let totalAlreadyBought = 0
          let totalSuiteDifferentPrice = 0

          let totalNoPaymentMethod = 0
          let totalFormRelease = 0
          let totalGuarantees = 0
          let totalNoProcessed = 0
          let totalExpensiveDelivery = 0
          let totalNoPayTax = 0
          let totalNoClientNearby = 0
          let totalOtherInformation = 0
          let totalWonGift = 0
          let totalLanguageBarrier = 0
          let totalWrongNumber = 0
          let totalDropCall = 0
          let totalSilent = 0
          let totalUnder18 = 0
          let totalAnyReasons = 0
          let totalAnother = 0

          const totalPercentCanceled = reasonCount => Helper.percents(totalCancel, reasonCount)

          this.rows.forEach(item => {
            totalProcessed += item.processed_all.value
            totalApproved += parseInt(item.approved.approvedSum)
            totalAverageBill += parseFloat(item.averageBill.averageBillTotal)
            totalCancel += parseInt(item.total_cancel.value)
            totalExpensive += parseInt(item.expensive.value)
            totalChangedMind += parseInt(item.changed_mind.value)
            totalBadReputation += parseInt(item.bad_reputation.value)
            totalConsultation += parseInt(item.consultation.value)
            totalNotAllowed += parseInt(item.not_allowed.value)
            totalMedicalContraindications += parseInt(item.medical_contraindications.value)
            totalNotOrder += parseInt(item.not_order.value)
            totalNotRingingLongTime += parseInt(item.not_ringing_long_time.value)
            totalNotMakeContact += parseInt(item.not_make_contact.value)
            totalNoCoverage += parseInt(item.no_coverage.value)
            totalBlacklistedCustomer += parseInt(item.blacklisted_customer.value)
            totalNotDeliveryTime += parseInt(item.not_delivery_time.value)
            totalAlreadyBought += parseInt(item.already_bought.value)
            totalSuiteDifferentPrice += parseInt(item.suite_different_price.value)
            totalNoPaymentMethod += parseInt(item.no_payment_method.value)
            totalFormRelease += parseInt(item.form_release.value)
            totalGuarantees += parseInt(item.want_guarantees.value)
            totalNoProcessed += parseInt(item.not_processed.value)
            totalExpensiveDelivery += parseInt(item.expensive_delivery.value)
            totalNoPayTax += parseInt(item.no_pay_tax.value)
            totalNoClientNearby += parseInt(item.no_nearby.value)
            totalOtherInformation += parseInt(item.other_information.value)
            totalWonGift += parseInt(item.won_gift.value)
            totalLanguageBarrier += parseInt(item.language_barrier.value)
            totalWrongNumber += parseInt(item.wrong_data.value)
            totalDropCall += parseInt(item.drop_calls.value)
            totalSilent += parseInt(item.silent.value)
            totalUnder18 += parseInt(item.under_18.value)
            totalAnyReasons += parseInt(item.any_reasons.value)
            totalAnother += parseInt(item.another.value)

            totalCancelRed = sum([
              totalExpensive,
              totalChangedMind,
              totalBadReputation,
              totalConsultation,
              totalNotAllowed,
              totalMedicalContraindications,
              totalNoPaymentMethod,
              totalFormRelease,
              totalGuarantees,
              totalNoProcessed,
              totalExpensiveDelivery,
              totalNoPayTax
            ])

            totalCancelGray = sum([
              totalNotOrder,
              totalNotRingingLongTime,
              totalNotMakeContact,
              totalNoCoverage,
              totalBlacklistedCustomer,
              totalNotDeliveryTime,
              totalAlreadyBought,
              totalSuiteDifferentPrice,
              totalNoClientNearby,
              totalOtherInformation,
              totalWonGift,
              totalLanguageBarrier,
              totalWrongNumber,
              totalDropCall,
              totalSilent,
              totalUnder18,
              totalAnyReasons,
              totalAnother
            ])
          })

          this.footColumns = {
            label: {
              value: this.$root.$t('statistic.in_total')
            },
            total: {
              value: totalProcessed
            },
            approved: {
              value: Helper.percents(totalProcessed, totalApproved)
            },
            averageBill: {
              value: Helper.averageBillDayCount(totalAverageBill, totalApproved)
            },
            total_cancel: {
              value: totalCancel
            },
            total_cancel_red: {
              value: totalPercentCanceled(totalCancel)
            },
            total_cancel_gray: {
              value: totalPercentCanceled(totalCancelGray)
            },

            expensive: {
              value: totalExpensive
            },
            expensivePercent: {
              value: totalPercentCanceled(totalExpensive)
            },

            changed_mind: {
              value: totalChangedMind
            },
            changed_mindPercent: {
              value: totalPercentCanceled(totalChangedMind)
            },

            no_payment_method: {
              value: totalNoPaymentMethod
            },
            no_payment_methodPercent: {
              value: totalPercentCanceled(totalNoPaymentMethod)
            },

            bad_reputation: {
              value: totalBadReputation
            },
            bad_reputationPercent: {
              value: totalPercentCanceled(totalBadReputation)
            },

            form_release: {
              value: totalFormRelease
            },
            form_releasePercent: {
              value: totalPercentCanceled(totalFormRelease)
            },

            want_guarantees: {
              value: totalGuarantees
            },
            want_guaranteesPercent: {
              value: totalPercentCanceled(totalGuarantees)
            },

            medical_contraindications: {
              value: totalMedicalContraindications
            },
            medical_contraindicationsPercent: {
              value: totalPercentCanceled(totalMedicalContraindications)
            },

            not_allowed: {
              value: totalNotAllowed
            },
            not_allowedPercent: {
              value: totalPercentCanceled(totalNotAllowed)
            },

            consultation: {
              value: totalConsultation
            },
            consultationPercent: {
              value: totalPercentCanceled(totalConsultation)
            },

            not_processed: {
              value: totalNoProcessed
            },
            not_processedPercent: {
              value: totalPercentCanceled(totalNoProcessed)
            },

            expensive_delivery: {
              value: totalExpensiveDelivery
            },
            expensive_deliveryPercent: {
              value: totalPercentCanceled(totalExpensiveDelivery)
            },

            no_pay_tax: {
              value: totalNoPayTax
            },
            no_pay_taxPercent: {
              value: totalPercentCanceled(totalNoPayTax)
            },

            not_order: {
              value: totalNotOrder
            },
            not_orderPercent: {
              value: totalPercentCanceled(totalNotOrder)
            },

            not_delivery_time: {
              value: totalNotDeliveryTime
            },
            not_delivery_timePercent: {
              value: totalPercentCanceled(totalNotDeliveryTime)
            },

            already_bought: {
              value: totalAlreadyBought
            },
            already_boughtPercent: {
              value: totalPercentCanceled(totalAlreadyBought)
            },

            no_nearby: {
              value: totalNoClientNearby
            },
            no_nearbyPercent: {
              value: totalPercentCanceled(totalNoClientNearby)
            },

            suite_different_price: {
              value: totalSuiteDifferentPrice
            },
            suite_different_pricePercent: {
              value: totalPercentCanceled(totalSuiteDifferentPrice)
            },

            other_information: {
              value: totalOtherInformation
            },
            other_informationPercent: {
              value: totalPercentCanceled(totalOtherInformation)
            },

            won_gift: {
              value: totalWonGift
            },
            won_giftPercent: {
              value: totalPercentCanceled(totalWonGift)
            },

            language_barrier: {
              value: totalLanguageBarrier
            },
            language_barrierPercent: {
              value: totalPercentCanceled(totalLanguageBarrier)
            },

            wrong_data: {
              value: totalWrongNumber
            },
            wrong_dataPercent: {
              value: totalPercentCanceled(totalWrongNumber)
            },

            not_ringing_long_time: {
              value: totalNotRingingLongTime
            },
            not_ringing_long_timePercent: {
              value: totalPercentCanceled(totalNotRingingLongTime)
            },

            drop_calls: {
              value: totalDropCall
            },
            drop_callsPercent: {
              value: totalPercentCanceled(totalDropCall)
            },

            not_make_contact: {
              value: totalNotMakeContact
            },
            not_make_contactPercent: {
              value: totalPercentCanceled(totalNotMakeContact)
            },

            silent: {
              value: totalSilent
            },
            silentPercent: {
              value: totalPercentCanceled(totalSilent)
            },

            no_coverage: {
              value: totalNoCoverage
            },
            no_coveragePercent: {
              value: totalPercentCanceled(totalNoCoverage)
            },

            blacklisted_customer: {
              value: totalBlacklistedCustomer
            },
            blacklisted_customerPercent: {
              value: totalPercentCanceled(totalBlacklistedCustomer)
            },

            under_18: {
              value: totalUnder18
            },
            under_18Percent: {
              value: totalPercentCanceled(totalUnder18)
            },

            any_reasons: {
              value: totalAnyReasons
            },
            any_reasonsPercent: {
              value: Helper.percents(totalCancel, totalAnyReasons)
            },
            another: {
              value: totalAnother
            },
            anotherPercent: {
              value: Helper.percents(totalCancel, totalAnother)
            }
          }

          this.$root.$emit('data_loaded')
        }).catch(response => {
          this.$root.$emit('data_loaded')
          console.log('err')
          this.$notify({
            type: 'danger',
            title: this.$root.$t('verbs.error'),
            text: !response.body.message ? response.body : response.body.message,
            animationType: 'velocity'
          })
        })
      })
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// CancelOperators.vue?060f2cbf